import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getPointHistory } from '../../api/tiers.api';
import {
  AllPointsHistory,
  ReceivedPointsHistory,
  UsedPointsHistory
} from '../../components/points-history';

const PointsHistorySkeleton = () => (
  <div className="mx-auto mt-4 flex w-full flex-col gap-y-4">
    {Array.from({ length: 3 }).map((_, index) => (
      <div key={index} className="animate-pulse bg-gray-50 p-6 py-3">
        <div className="flex w-full items-center justify-between">
          <div className="h-4 w-16 rounded bg-gray-200"></div>
          <div className="h-5 w-5 rounded bg-gray-200"></div>
        </div>
      </div>
    ))}
  </div>
);

export default function TiersHistory() {
  const params = useParams<{ id: string }>();
  const entityId = params.id;

  const { data: pointsHistoryData, isLoading } = useQuery({
    queryKey: ['pointsHistory', entityId],
    queryFn: () => getPointHistory(entityId || ''),
    enabled: !!entityId
  });

  if (isLoading) {
    return <PointsHistorySkeleton />;
  }

  return (
    <div className="mx-auto mt-4 flex w-full flex-col gap-y-4">
      {pointsHistoryData?.data?.length === 0 && (
        <div className="text-center text-gray-500">
          No points history available for this tier.
        </div>
      )}
      {pointsHistoryData?.data && pointsHistoryData.data?.length > 0 && (
        <div>
          <AllPointsHistory pointsData={pointsHistoryData?.data} />
          <ReceivedPointsHistory pointsData={pointsHistoryData?.data} />
          <UsedPointsHistory pointsData={pointsHistoryData?.data} />
        </div>
      )}
    </div>
  );
}
